import BENCHMARK_DATA from "@/data/benchmarks.json";
import { getPeerComparison } from "@/lib/benchmarks";

// Peer comparison for an analysis, worked out when it is viewed rather than stored with
// it, so older saved results use the current benchmark release
export function getAnalysisPeerComparison(analysisData) {
  return getPeerComparison({
    analysis: analysisData,
    data: BENCHMARK_DATA,
    industry: analysisData?.company_info?.industry,
    index: analysisData?.company_info?.index,
  });
}
